module.exports = __webpack_public_path__ + "img/frame1.52717e92.png";